/**
 * Shared constants for the Client Portal.
 * Used by ClientLayout, ClientDashboard, VisitHistory, ClientLocations.
 */

// Host Me operations WhatsApp number (international format, no +)
// Same number as HOSTME_OPS_PHONE in backend .env (0555689666)
export const WHATSAPP_NUMBER = '966555689666';
